import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import ModelsCarItem from '../models/Catalogs/ModelsCarItem';

/**
 * Returns the brand name for the given id
 * Note that id must match `code` in this case
 *
 * @param id - The id to look for
 * @param brands - The list of brands to filter
 */
export function brandNameForId(
  id: string,
  brands: GeneralCatalogItem[],
): string {
  const filteredBrands = brands.filter(
    (brand: GeneralCatalogItem): boolean => brand.code === id,
  );
  if (filteredBrands.length <= 0) {
    return '';
  }
  return filteredBrands[0].name;
}

/**
 * Returns the model name for the given id
 * Note that id must match `code` in this case
 *
 * @param id - The id to look for
 * @param models - The list of models to filter
 */
export function modelNameForId(id: string, models: ModelsCarItem[]): string {
  const filteredModels = models.filter(
    (model: ModelsCarItem): boolean => model.code === id,
  );
  if (filteredModels.length <= 0) {
    return '';
  }
  return filteredModels[0].name;
}

export function getMinCodeValueOnList(items: GeneralCatalogItem[]): number {
  const lowerItem = [...items]
    .sort(
      (left, right): number =>
        parseInt(right.code, 10) - parseInt(left.code, 10),
    )
    .pop();
  if (lowerItem) {
    return parseInt(lowerItem.code, 10);
  }
  return 1;
}

export function getMaxCodeValueOnList(items: GeneralCatalogItem[]): number {
  const upperItem = [...items]
    .sort(
      (left, right): number =>
        parseInt(left.code, 10) - parseInt(right.code, 10),
    )
    .pop();
  if (upperItem) {
    return parseInt(upperItem.code, 10);
  }
  return 1;
}
